import { DraftParams } from './types';

export const validate = (_params: DraftParams): string[] => {
  return [];
};

export const getName = (_params: DraftParams) => {
  return 'Bias Statistic by Historical Beta';
};
